import React from 'react';
import CommonWrap from '../common-wrap';


const PictureWrap = () => {
    const tabs = [ { id: '1', tab: '任务图片'},{ id: '2', tab: '稿件图片'} ];
    const title = '图片池';
    return(
        <CommonWrap tabs={tabs} title={title}/>
    ) 
}


export default PictureWrap